/* eslint-disable import/prefer-default-export */
export { default as GLOBAL_STORE } from './storeGlobal';
